var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.666504C4.55021 0.666504 3.375 1.84171 3.375 3.2915C3.375 4.46359 5.09062 6.59984 5.74792 7.37525C5.88104 7.53234 6.11917 7.53234 6.25208 7.37525C6.90938 6.59984 8.625 4.46359 8.625 3.2915C8.625 1.84171 7.44979 0.666504 6 0.666504ZM6 4.1665C5.51667 4.1665 5.125 3.77484 5.125 3.2915C5.125 2.80817 5.51667 2.4165 6 2.4165C6.48333 2.4165 6.875 2.80817 6.875 3.2915C6.875 3.77484 6.48333 4.1665 6 4.1665ZM0.419167 5.16546C0.295454 5.21494 0.189402 5.30035 0.114689 5.41068C0.0399768 5.521 2.96293e-05 5.65118 0 5.78442L0 10.9994C0 11.2353 0.238125 11.3965 0.457083 11.309L3.33333 9.99984V5.144C3.14917 4.81109 2.99854 4.48692 2.89062 4.17692L0.419167 5.16546ZM6 8.15963C5.70688 8.15963 5.42958 8.03088 5.23938 7.80629C4.82979 7.32296 4.39417 6.77254 4 6.20796V9.99963L8 11.333V6.20817C7.60583 6.77255 7.17042 7.32317 6.76063 7.8065C6.57042 8.03088 6.29313 8.15963 6 8.15963ZM11.5429 4.024L8.66667 5.33317V11.3332L11.5808 10.1675C11.7046 10.1181 11.8106 10.0327 11.8853 9.92235C11.9601 9.81202 12 9.68183 12 9.54859V4.33359C12 4.09775 11.7619 3.9365 11.5429 4.024Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.b297f17a3001bf0cc00ffd8c25bf6e2e.svg";
export { ForwardRef as ReactComponent };